exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.basket-product-width[data-v-2e3263d0] {\n    width: 95%;\n}\n.basket-product-image[data-v-2e3263d0] {\n    max-width: 100px;\n}\n.close-icon[data-v-2e3263d0] {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n}\n.text-decoration-line-through[data-v-2e3263d0] {\n    text-decoration: line-through!important;\n}\n@media screen and (max-width: 800px){\n.basket-product-image[data-v-2e3263d0] {\n        max-width: 80px;\n}\n.basket-product-width[data-v-2e3263d0] {\n        width: 90%;\n}\n}\n", ""]);

// exports
